function preventSubmitOnEnter(event: React.KeyboardEvent): void {
  if (event.code === "Enter") {
    event.preventDefault();
  }
}

export default preventSubmitOnEnter;
